'use strict';

var _ = require('lodash');
var KpiRibbonTooltipDirective = function KpiRibbonTooltipDirective(kpiRibbonService) {
  return {
    restrict: 'A',
    scope: {
      item: '=',
      screenState: '='
    },
    link: function link(scope, element) {
      var REFERENCE_MODE_LABELS = {
        lastYear: 'LY',
        referenceYear: 'RY',
        seasonalAverage: 'Season Avg'
      };
      function getReferenceLabel() {
        var referenceKey = _.get(scope, 'screenState.selectedReference');
        return REFERENCE_MODE_LABELS[referenceKey] || REFERENCE_MODE_LABELS.lastYear;
      }
      var tooltipContentTemplate = _.template(require('../templates/tooltip-content.html'));
      var kpiElementData = scope.item;
      var tooltipDataModel = {
        metrics: []
      };

      //place only needed metrics in needed order
      var availableMetrics = {
        'Current': [],
        'Expected': [],
        'CurrentLY': [],
        'CurrentRY': [],
        'CurrentSeason Avg': [],
        'FinalLY': [],
        'FinalRY': [],
        'FinalSeason Avg': [],
        'Final': [],
        'Target': [],
        'Demand': [],
        'Demand Adjusted': [],
        'MWTP': [],
        'Optimal': [],
        'Actual': [],
        'Gap': [],
        'Spill': [],
        'Recapture': [],
        'Rev Opp %': []
      };
      for (var i in kpiElementData.metrics) {
        var metric = kpiElementData.metrics[i];
        var metricValueFormatted = kpiRibbonService.formatMetric(metric);
        if (kpiElementData.simplifiedTooltip) {
          availableMetrics[kpiElementData.name].push({
            title: kpiElementData.name,
            value: metricValueFormatted
          });
        } else if (metric.name === 'Current' || metric.name === 'Expected' || metric.name === 'Final') {
          availableMetrics[metric.name].push({
            title: metric.name + ' ' + kpiElementData.name,
            value: metricValueFormatted
          });
          var referenceLabel = getReferenceLabel();
          if (_.isNumber(metric.lastYearValue)) {
            var metricNameLY = metric.name === 'Expected' ? 'Final' : metric.name;
            availableMetrics[metricNameLY + referenceLabel].push({
              title: metricNameLY + ' ' + kpiElementData.name + ' ' + referenceLabel,
              value: kpiRibbonService.formatMetric(metric, metric.lastYearValue)
            });
          }
          if (_.isNumber(metric.referenceYearValue)) {
            var metricNameRY = metric.name === 'Expected' ? 'Final' : metric.name;
            availableMetrics[metricNameRY + referenceLabel].push({
              title: metricNameRY + ' ' + kpiElementData.name + ' ' + referenceLabel,
              value: kpiRibbonService.formatMetric(metric, metric.referenceYearValue)
            });
          }
        } else if (kpiElementData.name === 'Demand' && metric.name !== 'MWTP') {
          availableMetrics[kpiElementData.name].push({
            title: 'Model Demand',
            value: metricValueFormatted
          });
          if (_.isNumber(metric.lastYearValue) && _.get(availableMetrics, kpiElementData.name + ' Adjusted')) {
            availableMetrics[kpiElementData.name + ' Adjusted'].push({
              title: 'Eff Demand',
              value: kpiRibbonService.formatMetric(metric, metric.lastYearValue)
            });
          }
        } else if (availableMetrics.hasOwnProperty(metric.name)) {
          availableMetrics[metric.name].push({
            title: metric.name,
            value: metricValueFormatted
          });
        }
      }
      for (var name in availableMetrics) {
        tooltipDataModel.metrics.push.apply(tooltipDataModel.metrics, availableMetrics[name]);
      }
      function showTooltip() {
        element.popover({
          content: function content() {
            return tooltipContentTemplate(tooltipDataModel);
          },
          html: true,
          placement: 'bottom',
          container: 'body'
        });
        element.popover('show');
      }
      function hideTooltip() {
        element.popover('hide');
      }
      element.on('mouseenter', showTooltip);
      element.on('mouseleave', hideTooltip);
      scope.$on('$destroy', function () {
        element.off('mouseenter', showTooltip);
        element.off('mouseleave', hideTooltip);
        hideTooltip();
      });
    }
  };
};
KpiRibbonTooltipDirective.$inject = ['KpiRibbonService'];
module.exports = KpiRibbonTooltipDirective;